<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import type { PostalRecipientFormValue } from "./contract"
  let {
    value = $bindable(),
    manual,
    disabled = false,
    showHint = true,
  }: {
    value: PostalRecipientFormValue
    manual: boolean
    disabled?: boolean
    showHint?: boolean
  } = $props()
  const id = $props.id()
  const fields = [
    { key: "recipientName", label: "Name" },
    { key: "street", label: "Straße" },
    { key: "house_number", label: "Hausnummer" },
    { key: "address_extra", label: "Adresszusatz" },
    { key: "zip", label: "PLZ" },
    { key: "city", label: "Ort" },
    { key: "country", label: "Land" },
  ] as const
</script>

<div class="postal-form form light">
  {#each fields as field}
    <Input
      id={`${id}-${field.key}`}
      type="text"
      label={field.label}
      placeholder={field.label}
      bind:value={value[field.key]}
      required={field.key !== "address_extra"}
      disabled={disabled || (field.key !== "recipientName" && !manual)}
      surfaceTone="light"
      brightBackground={true}
      style="width:100%;min-width:0;"
    />
  {/each}
</div>
{#if showHint}<p class="postal-hint"
    >{manual
      ? "Mit der Gesamtbestätigung werden dieser Ansprechpartner und seine Postadresse gespeichert."
      : "Eine Namensänderung benennt bei der Gesamtbestätigung auch den gespeicherten Ansprechpartner um. Für eine andere Adresse wählen Sie „Individuell erfassen“."}</p
  >{/if}

<style>
  .postal-form {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
    min-width: 0;
  }
  .postal-hint {
    font-size: 0.85rem;
    margin: 0.8rem 0;
    color: var(--text-invers-100);
  }
  @media (max-width: 500px) {
    .postal-form {
      grid-template-columns: minmax(0, 1fr);
    }
  }
</style>
